import { stripHtmlTags } from '@change-corgi/core/html';

import { usePetitionCommentPageData } from '#src/app/pages/petitionComment/pageContext';

type Result = ModelHookResult<{
	comment: string;
}>;

export function usePageBody(): Result {
	const {
		data: {
			comment: { comment },
		},
	} = usePetitionCommentPageData();

	return {
		data: {
			// some comments somehow contain links in HTML format
			comment: stripHtmlTags(comment),
		},
	};
}
